import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1f896bac")

_pushScopeId("data-v-1f896bac")
const _hoisted_1 = {
  for: "active",
  class: "kn-material-input-label p-ml-3"
}
const _hoisted_2 = { class: "p-fluid p-m-2" }
const _hoisted_3 = { class: "p-field p-d-flex" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "title",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "expirationDate",
  id: "calendar-label"
}
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = { class: "p-d-flex p-flex-row p-jc-between" }
const _hoisted_14 = { id: "description-help" }
const _hoisted_15 = { class: "p-field" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Editor = _resolveComponent("Editor")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    style: _ctx.newsDetailCardDescriptor.card.style
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.newsManagement.settings')), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_InputSwitch, {
            id: "active",
            modelValue: _ctx.news.active,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.news.active = $event)),
            onChange: _ctx.onActiveChange,
            "data-test": "active-input"
          }, null, 8, ["modelValue", "onChange"]),
          _createVNode("label", _hoisted_1, _toDisplayString(_ctx.$t('managers.newsManagement.active')), 1)
        ]),
        _: 1
      })
    ]),
    content: _withId(() => [
      _createVNode("form", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", {
            style: _ctx.newsDetailCardDescriptor.input.title.style
          }, [
            _createVNode("span", _hoisted_4, [
              _createVNode(_component_InputText, {
                id: "title",
                class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.news.title.$invalid && _ctx.v$.news.title.$dirty
                                }],
                type: "text",
                modelValue: _ctx.v$.news.title.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.news.title.$model = $event)),
                modelModifiers: { trim: true },
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.news.title.$touch())),
                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFieldChange('title', $event.target.value))),
                "data-test": "title-input"
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.newsManagement.form.title')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.news.title,
              additionalTranslateParams: {
                                fieldName: _ctx.$t('managers.newsManagement.form.title')
                            }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ], 4),
          _createVNode("div", {
            style: _ctx.newsDetailCardDescriptor.input.expirationDate.style
          }, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_Calendar, {
                id: "expirationDate",
                class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.news.expirationDate.$invalid && _ctx.v$.news.expirationDate.$dirty
                                }],
                type: "text",
                modelValue: _ctx.v$.news.expirationDate.$model,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.news.expirationDate.$model = $event)),
                showIcon: true,
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.news.expirationDate.$touch())),
                onInput: _ctx.onManualDateChange,
                onDateSelect: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onFieldChange('expirationDate', $event.valueOf()))),
                "data-test": "expiration-input"
              }, null, 8, ["modelValue", "class", "onInput"]),
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.newsManagement.form.expirationDate')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.news.expirationDate,
              additionalTranslateParams: {
                                fieldName: _ctx.$t('managers.newsManagement.form.expirationDate')
                            }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ], 4),
          _createVNode("div", {
            style: _ctx.newsDetailCardDescriptor.input.type.style
          }, [
            _createVNode("span", _hoisted_8, [
              _createVNode(_component_Dropdown, {
                id: "type",
                class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.news.type.$invalid && _ctx.v$.news.type.$dirty
                                }],
                modelValue: _ctx.v$.news.type.$model,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.news.type.$model = $event)),
                options: _ctx.newsDetailCardDescriptor.newsTypes,
                optionLabel: "name",
                optionValue: "value",
                onBeforeShow: _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.news.type.$touch())),
                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onFieldChange('type', $event.value)))
              }, null, 8, ["class", "modelValue", "options"]),
              _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('managers.newsManagement.form.type')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.news.type,
              additionalTranslateParams: {
                                fieldName: _ctx.$t('managers.newsManagement.form.type')
                            }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ], 4)
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('managers.newsManagement.form.description')) + " * ", 1),
          _createVNode("span", _hoisted_12, [
            _createVNode(_component_Textarea, {
              id: "description",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.news.description.$invalid && _ctx.v$.news.description.$dirty
                            }],
              modelValue: _ctx.v$.news.description.$model,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.news.description.$model = $event)),
              modelModifiers: { trim: true },
              autoResize: true,
              maxLength: "140",
              rows: "2",
              placeholder: _ctx.$t('managers.newsManagement.form.descriptionPlaceholder'),
              onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.v$.news.description.$touch())),
              onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onFieldChange('description', $event.target.value))),
              "data-test": "description-input"
            }, null, 8, ["modelValue", "class", "placeholder"])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", null, [
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.news.description,
                additionalTranslateParams: {
                                    fieldName: _ctx.$t('managers.newsManagement.form.description')
                                }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("small", _hoisted_14, _toDisplayString(_ctx.descriptionHelp), 1)
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("span", null, [
            _createVNode(_component_Editor, {
              id: "html",
              modelValue: _ctx.news.html,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.news.html = $event)),
              editorStyle: _ctx.newsDetailCardDescriptor.editor.style,
              onTextChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onFieldChange('html', $event.htmlValue)))
            }, null, 8, ["modelValue", "editorStyle"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["style"]))
})